<template>
<div class="rights_box no-trans" v-loading="loading">
  
    <div class="new_lists">
        <div class="new_item" v-for="(item,index) in vuex_new_list2" v-if="index<2"  @click="$router.push('/hot_spot_type_detial?id='+item.id)">
            <div class="new_img">
                <img :src="item.thumb" alt="">
            </div>
            <div class="new_info">
                <div class="new_title">
                   {{ item.title }}
                </div>
                <div class="new_icons">
                    <div class="icons">
                        <img src="../../../assets/img/index/comments_case/see.png" alt="">
                        {{ item.views }}

                    </div>
                    <div class="icons">
                        <img src="../../../assets/img/index/comments_case/time.png" alt="">
                        {{ item.created_at }}

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="r_bom" v-if="!mobile_view || $store.state.vuex_lawyers.length">
        <div class="banner_title">推荐律师</div>

        <div class="change_box">
            <div class="change_item" :class="{ 'change_item_ac': banner_ac == index }"
                v-for="(item, index) in $store.state.vuex_lawyers" :key="index"></div>
        </div>
        <el-carousel :autoplay="true" :indicator-position="'none'" @change="change_banner">
            <el-carousel-item v-for="(item, index) in $store.state.vuex_lawyers" :key="index">
                <div class="banner_box">
                    <div class="borders_box">
                        <div class="borders1"></div>
                        <div class="borders2">
                            <img :src="item.business_img" alt="">

                        </div>
                        <div class="tage_box" v-if="item.elite==1">
                            <div class="tages">金牌律师</div>
                        </div>
                    </div>
                    <div class="ls_name">{{item.name}}律师</div>

                    <div class="ls_texts">{{minx_get_causeIds(item.causeIds)}}</div>
                    <div class="btns_flex">
                        <div class="btns" @click="$router.push('/lawyer_detial?id='+item.id)">
                            <img src="@/assets/img/index/legal/icons1.png" alt="">

                            快速咨询
                        </div>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</div>
</template>
<script>
import {
    mapState
} from 'vuex'



export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            banner_ac: 0,
            banner_list: [1, 2, 3]

        }
    },
    computed: {
        ...mapState(['vuex_new_list2'])

    },
    watch: {

    },
    created() {

    },
    methods: {
        change_banner(e) {
            // console.log('却换触发',e)
            this.banner_ac = e
        },
    },

}
</script>
<style scoped lang="less">
.rights_box {
    width: 420px;
    min-height: 100px;

    // background-color: red;
    .r_top {
        width: 420px;
        height: 300px;
        position: relative;
        padding: 32px 36px;
        // background-image: url("@/assets/img/index/legal/r_top_bg.png" );
        background-image: url('../../../assets/img/index/legal/r_top_bg.png');
        background-size: 100%;

        // .imgs{
        //     width: 420px;
        //     height: 300px;
        //     position: absolute;
        //     left: 0;
        //     top: 0;
        // }
        .titles {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #333333;

        }

        .text1 {
            padding-top: 14px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;

        }

        .nums {
            padding-top: 20px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 36px;
            color: #377CFD;

        }

        .text2 {

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;

        }

        .btns_box {
            padding-top: 40px;

            .btns {
                width: 180px;
                height: 40px;
                background: #377CFD;
                box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                border-radius: 4px 4px 4px 4px;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 14px;
                color: #FFFFFF;
            }
        }
    }
    .new_lists{
        // padding-top: 24px;
        .new_item{
            width: 416px;
            height: 390px;
            background: #FFFFFF;
            box-shadow: 0px 0px 40px 1px rgba(55,124,253,0.08);
            border-radius: 0px 0px 0px 0px;
            margin-bottom: 24px;
            cursor: pointer;
            .new_img{
                width: 100%;
                height: 255px;
                img{
                    width: 100%;
                    height: 255px;
                }
            }
            .new_info{
                padding: 20px 24px 24px 24px;
                .new_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 20px;
                    color: #000B33;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp:2;
                    -webkit-box-orient: vertical;
                }
                .new_icons{
                    display: flex;
                    align-items: center;
                    padding-top: 20px;
                    .icons{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        margin-right: 24px;

                        img{
                            height: 15px;
                            margin-right: 8px;
                        }
                    }
                }
            }
        }
    }

    .r_bom {
        width: 420px;
        height: 460px;
        // background: red;
        margin-top: 24px;
        position: relative;

        .banner_title {
            position: absolute;
            top: 24px;
            left: 32px;
            display: flex;
            align-items: center;
            z-index: 100;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
        }

        .change_box {
            position: absolute;
            top: 32px;
            right: 32px;
            display: flex;
            align-items: center;
            z-index: 100;

            .change_item {
                width: 6px;
                height: 6px;
                background: #F2F2F5;
                border-radius: 50%;
                margin-left: 6px;
            }

            .change_item_ac {
                background: #377CFD;
            }
        }

        /deep/.el-carousel {
            width: 100%;
            height: 100%;

            .el-carousel__container {
                width: 100%;
                height: 100%;

                .banner_box {
                    width: 100%;
                    height: 100%;
                    background-image: url('../../../assets/img/index/legal/banner_bg2.png');
                    background-size: 100%;
                    padding-top: 88px;

                    .borders_box {
                        width: 160px;
                        height: 160px;
                        margin: auto;
                        border-radius: 50%;
                        // margin-top: 88px; 
                        // background: #FFFFFF;
                        // opacity: 0.2;
                        position: relative;

                        .borders1 {
                            width: 160px;
                            height: 160px;
                            background: #FFFFFF;
                            opacity: 0.2;
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: 1;
                            border-radius: 50%;

                        }

                        .borders2 {
                            width: 132px;
                            height: 132px;
                            background: #C4C4C4;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            z-index: 2;
                            border-radius: 50%;

                            transform: translate(-50%, -50%);

                            img {
                                width: 132px;
                                height: 132px;
                                border-radius: 50%;

                            }
                        }

                        .tage_box {
                            width: 100%;
                            position: absolute;
                            z-index: 3;
                            bottom: -4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .tages {
                                cursor: pointer;
                                width: 104px;
                                height: 32px;
                                background: linear-gradient(180deg, #FAECC6 0%, #F2CF85 100%);
                                border-radius: 16px 16px 16px 16px;
                                border: 1px solid #876052;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #6C3E2D;
                                text-align: center;
                                line-height: 32px;
                            }
                        }

                    }

                    .ls_name {
                        padding-top: 28px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 24px;
                        color: #333333;
                        text-align: center;
                    }

                    .ls_texts {
                        padding-top: 14px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        text-align: center;
                    }

                    .btns_flex {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 40px;

                        .btns {
                            width: 180px;
                            height: 40px;
                            background: #377CFD;
                            box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                            border-radius: 4px 4px 4px 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            line-height: 40px;
                            text-align: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;

                            img {
                                width: 14px;
                                height: 14px;
                                margin-right: 10px;
                            }
                        }
                    }
                }
            }

            .el-carousel__indicators {
                //  display: none;
            }
        }
    }
}
</style>
<style scoped lang="less">
@import "../../../styles/mobile-patterns.less";

@media (max-width: 1024px) {
    .rights_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        width: 100%;
    }
    .rights_box.no-trans .r_top {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        padding: 16px 16px;
    }
    .rights_box.no-trans .r_top .titles {
        font-size: 24px;
    }
    .rights_box.no-trans .r_top .text1 {
        padding-top: 14px;
        font-size: 14px;
    }
    .rights_box.no-trans .r_top .nums {
        padding-top: 16px;
        font-size: 24px;
    }
    .rights_box.no-trans .r_top .text2 {
        font-size: 14px;
    }
    .rights_box.no-trans .r_top .btns_box {
        padding-top: 16px;
    }
    .rights_box.no-trans .r_top .btns_box .btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .rights_box.no-trans .new_lists .new_item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        margin-bottom: 16px;
    }
    .rights_box.no-trans .new_lists .new_item .new_img {
        min-height: 0;
        height: auto;
    }
    .rights_box.no-trans .new_lists .new_item .new_img img {
        min-height: 0;
        height: auto;
    }
    .rights_box.no-trans .new_lists .new_item .new_info {
        padding: 16px 16px 16px 16px;
    }
    .rights_box.no-trans .new_lists .new_item .new_info .new_title {
        font-size: 20px;
    }
    .rights_box.no-trans .new_lists .new_item .new_info .new_icons {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .rights_box.no-trans .new_lists .new_item .new_info .new_icons .icons {
        font-size: 14px;
        margin-right: 16px;
    }
    .rights_box.no-trans .new_lists .new_item .new_info .new_icons .icons img {
        height: 15px;
        margin-right: 8px;
    }
    .rights_box.no-trans .r_bom {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        margin-top: 16px;
    }
    .rights_box.no-trans .r_bom .banner_title {
        top: 16px;
        left: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 18px;
    }
    .rights_box.no-trans .r_bom .change_box {
        top: 16px;
        right: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .rights_box.no-trans .r_bom .change_box .change_item {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-left: 6px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box {
        padding-top: 16px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box {
        width: 160px;
        height: 160px;
        margin: auto;
        border-radius: 50%;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders1 {
        width: 160px;
        height: 160px;
        border-radius: 50%;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders2 {
        width: 132px;
        height: 132px;
        border-radius: 50%;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders2 img {
        width: 132px;
        height: 132px;
        border-radius: 50%;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .tage_box {
        bottom: -4px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .tage_box .tages {
        width: 104px;
        height: 32px;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        line-height: 32px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .ls_name {
        padding-top: 16px;
        font-size: 24px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .ls_texts {
        padding-top: 14px;
        font-size: 14px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex {
        padding-top: 16px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex .btns {
        width: 180px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .rights_box.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex .btns img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
}

@media (max-width: 1024px) {
    .rights_box.no-trans .r_bom { .mobile-lawyer-recommendation(); }
}
</style>
